export default "__VITE_ASSET__BCYUapyI__"